@if (stdCartDetails?.orders) {
  <section [ngClass]="isSticky === true ? 'sticky' : 'header'">
    <div class="savings-total one sticky-total">
      <div class="row stickbar">
        <div class="col-md-12 col-sm-12 col-lg-12 m-0 p-0">
          <div class="orderTitleSticky">
            Order Total:
            @if (headerLevelObj?.length==0) {
              <span>
                {{ subTotalVal | currency : 'USD' :
                'symbol' : '1.2-2' }}
              </span>
            }
            @if (headerLevelObj?.length>0) {
              <span>$--</span>
            }
          </div>
          <p class="fw-bold m-0 p-0">Total Savings:&nbsp;@if (headerLevelObj?.length==0) {
            <span
              class="greenfont">{{totalSavings | currency : 'USD' :
            'symbol' : '1.2-2'}}</span>
            }@if (headerLevelObj?.length>0) {
            <span>$--</span>
          }</p>
        </div>
      </div>


    </div>
  </section>

  <section class="preheader no-print">
    <section class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right">
      <section class="col-lg-5 col-md-5 col-sm-0 col-xs-12 p0 float-left emptyheader"></section>
    <section class="
        col-lg-3 col-md-3 col-sm-6 col-xs-12
        middle-row
        mt0
        text-right
        float-left
      ">
        <div class="totalQuantityDisplayBlock">
          <div class="quantityDisplay">
          </div>
        </div>
        <a target="" id="continueShoppingId" data-di-id="#continueShoppingId" [routerLink]="['/Open-Catalogue/c/1']">
          <img src="/icons/{{baseSiteId}}/chevron-left.svg" alt="" class="chevron-left" />
          Continue shopping
        </a>
      </section>
    <section class="
        col-lg-4 col-md-4 col-sm-6 col-xs-12
        text-right
        float-right
        p0
        header-links">
        <section class="save-document save-document-container mb1 mt0">
          <ng-template #popSaveTitle>
            Name your order and save it for future orders
          </ng-template>
          <ng-template #popSaveContent>
            <input type="text" class="save-order" required #name="ngModel" [(ngModel)]="saveCartName"
              (keypress)="omit_special_char($event)" maxlength="30" />
            @if (name.errors?.required) {
              <span class="common-error required">{{
                errorMsg
              }}</span>
            }
            <span class="common-error required pt-1">{{ errorMsg }}</span>
            <div class="buttonDiv">
              <button type="reset" class="popover-close btn btn-secondary popover-cancel-button" (click)="toggleClose()">
                Cancel
              </button>
              <button class="btn btn-primary popover-cancel-button" type="submit" data-di-id="di-id-3064f17d-e97cc628"
                (click)="saveOrder()">
                Save
              </button>
            </div>
          </ng-template>
          <!--Temporary hiding add to fav using hideForNow class as its out of scope currently 4jan due to technical gap in api-->
          @if (!punchOutKey) {
            <a class="save-cart save-cart-img-section hideForNow" [ngbPopover]="popSaveContent"
              [popoverTitle]="popSaveTitle" triggers="manual" #p2="ngbPopover" placement="top" (click)="toggle(p2)"
              container="body" popoverClass="popover-links saveorder-incart {{baseSiteId}}">
              <img src="/icons/{{baseSiteId}}/saved-orders-plus.png" alt="Save order" /><span>
              Add to my favorites
            </span></a>
          }
          <ng-template #popTitle><span>
            Clear cart of all products?
          </span>
        </ng-template>
        <ng-template #popContent>
          <button type="reset" class="popover-close btn white-button popover-cancel-button"
            data-di-id="di-id-d01008be-fb6e135c" (click)="toggle(p1)">
            Cancel
          </button>
          <button class="btn blue-button popover-cancel-button" type="submit" data-di-id="di-id-3064f17d-e97cc628"
            (click)="clearChildCart()">
            Clear cart
          </button>
        </ng-template>

        <a href="javascript:void(0)" target="" aria-label="download as" class="xls_cart xls-cart-img-section"
          id="tealium-xls" data-di-id="#tealium-xls" (click)="exportXls()">
          <img src="/icons/{{baseSiteId}}/excel_new.png" alt="" />
          <span>
            XLS
          </span></a>
          <a href="javascript:void(0)" onclick="window.print();" target="" id="printLinkId" class="print-cart-img-section"
            data-di-id="#printLinkId">
            <img src="/icons/{{baseSiteId}}/print.svg" alt="" />
            <span>
              Print
            </span></a>
          </section>
        </section>
      </section>
    </section>
    @if (deleteSuccess !== '') {
      <div class="global-alerts">
        <div class="alert alert-info alert-dismissable getAccAlert">
          <button (click)="closeAlert()" class="close closeAccAlert" aria-hidden="true" data-dismiss="alert" type="button"
            data-di-id="di-id-4f6d7b93-70563360">
            ×
          </button>
          <span class="delete-succ" [innerHTML]="deleteSuccess"></span>{{ "addToCartItems.deleteSuccessMsg" | cxTranslate }}
        </div>
      </div>
    }
    @if (addSuccess) {
      <div class="global-alerts">
        <div class="alert alert-info alert-dismissable getAccAlert">
          <button (click)="closeAlert()" class="close closeAccAlert" aria-hidden="true" data-dismiss="alert" type="button"
            data-di-id="di-id-4f6d7b93-70563360">
            ×
          </button>
          {{ "addToCartItems.addProdSuccess" | cxTranslate }}
        </div>
      </div>
    }
    @if (orderBlock && showDangerAlert && productEntries?.length > 0) {
      <div class="global-alerts">
        <div class="alert alert-danger alert-dismissable getAccAlert">
          <button (click)="closeDangerAlert()" class="close closeAccAlert" aria-hidden="true" data-dismiss="alert"
            type="button" data-di-id="di-id-4f6d7b93-70563360">
            ×
          </button>
          {{ "addToCartItems.orderBlockMsg" | cxTranslate }}
        </div>
      </div>
    }
    <section class="standart-cart">

      <div class="row whitebg section-outer">
        <div class="col-sm-4 m-0 p-0 mb-orderSubtotal" style="border-left:4px solid #f4f2f6;">
      <aside class="
      col-md-12 col-sm-12 m-0 p-0
      right-navigation
      float-left
      left-align
      cart-main-page
    " [ngClass]="isSticky === true ? 'header' : ''" aria-label="subTotal">
            <section class="savings-total p-0 two">

              <div class="row">
                <div class="col-md-12 col-sm-12 col-lg-12 m-0 p-0">
                  <div class="background-grey">

                    <div class="orderTitleSticky">
                      Order Total:
                      @if (headerLevelObj?.length==0) {
                        <span>
                          {{ subTotalVal | currency : 'USD' :
                          'symbol' : '1.2-2' }}
                        </span>
                      }
                      @if (headerLevelObj?.length>0) {
                        <span>$--</span>
                      }
                    </div>
                    <p class="fw-bold m-0 p-0">Total Savings:&nbsp;@if (headerLevelObj?.length==0) {
                      <span
                        class="greenfont">{{totalSavings | currency : 'USD'
                        :
                      'symbol' : '1.2-2'}}</span>
                      }@if (headerLevelObj?.length>0) {
                      <span>$--</span>
                    }</p>

                  </div>

                </div>
              </div>



            </section>
          </aside>

        </div>
        <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8">

          <div class="row whitebgmb cart-accordion-outer">
            <section class="cart-accordion">
              <!-- accordion:start-->
              @for (locSpecificCart of stdCartDetails.orders; track locSpecificCart; let i = $index) {
                <div class="sanofi-accordion">
                  <div class="panel-group">
                    <div class="panel panel-default">
                      <div class="panel-heading">
                        <section class="first-level-acc ">
                          <section class="deli_loc clear_fix">
                            <section class="cart_shipto col-sm-6 col-md-6 col-lg-6 cart_shipto pl0">
                              <section class="firstLevel-acc cartShipToHeader ">
                                <section class="">
                                  <section class="ship-address">
                                    <section id="location-select">
                                      <section class="location-icon">
                                        <span class="glyph-icon">
                                          <i class="fas fa-map-marker-alt icon mr-3"></i>
                                        </span>
                                      </section>
                                      <section class="location-Details">
                                        <span class="selected-loc">
                                          {{locSpecificCart.shipToLoc_name}}
                                        ({{locSpecificCart.shipToLoc_id}})</span>
                                      </section>
                                    </section>
                                  </section>
                                </section>
                              </section>
                            </section>
                          </section>
                          @if (deliveryPickup=='pickup') {
                            <section class="ship_addr clear_fix">
                              <section class="col-sm-4 col-md-4 col-lg-4 cart_shipto pl0 float-left">
                                <h6>{{'addToCartItems.pickLocation'|cxTranslate}}</h6>
                                <p>
                                  {{'addToCartItems.sanofiName'|cxTranslate}}<br>{{'addToCartItems.locationLine1'|cxTranslate}}<br>{{'addToCartItems.locationLine2'|cxTranslate}}
                                </p>
                              </section>
                              <section class=" col-sm-6 col-md-6 col-lg-6 px0 float-left" [hidden]="getExpandedItems(i)">
                                <section class="delivery-content">
                                  <section class="delivary-details cart-pickup-date">
                                    <h6 class="requested-date"> {{'addToCartItems.pickupDate'|cxTranslate}}</h6>
                                    <section class="calender">
                                      <section class="form-horizontal mb0">
                                        <section class="control-group float-left">
                                          <section class="controls input-append date cart-delivery-date-picker" data-date=""
                                            data-date-format="mm/dd/yyyy" data-link-field="dtp_input2"
                                            data-link-format="mm/dd/yyyy">
                                            <span class="add-on"><i class="icon-th"></i>
                                          </span>
                                          <input type="text" placeholder="DD/MM/YYYY" class="delivery-pickup-calendar"
                                            bsDatepicker [(ngModel)]="pickupDate" [minDate]="minPickupDate"
                                            [daysDisabled]="[0,6]" [maxDate]="maxPickupDate"
                                            (bsValueChange)="onPickupDateChange($event)"
                                            [bsConfig]="{ containerClass: 'theme-green deliveryPickup' }">
                                        </section>
                                      </section>
                                      <ng-select [items]="timeFormat" bindLabel="name" bindValue="selectedTime"
                                        [multiple]="false" name="selectedTime" placeholder="Set Time"
                                        [(ngModel)]="selectedTime" [searchable]="false">
                                      </ng-select>
                                    </section>
                                  </section>
                                </section>
                                <p class="pickupTextMsg">
                                  {{'addToCartItems.pickupMsg'|cxTranslate}}
                                  <br>{{'addToCartItems.customerService'|cxTranslate}}
                                    {{'addToCartItems.customerServiceNo'|cxTranslate}}
                                  </p>
                                </section>
                              </section>
                            </section>
                          }
                        </section>
                      </div>
                    </div>
                  </div>
                  <section [hidden]="getExpandedItems(i)" class="row">
                    <section class="col-lg-12 col-md-12 col-sm-12 label-location">
                      <table class="alignRight location-table">
                        @if (locSpecificCart?.cartType !== 'INFLUENZA') {
                          <tr>
                            <td class="ff-bold">Order #:</td>
                            <td class="fw-bold">{{locSpecificCart?.code}}</td>
                          </tr>
                        }
                        @if (locSpecificCart?.cartType !== 'INFLUENZA') {
                          <tr>
                            <td class="ff-bold">PO #:</td>
                            <td class="fw-bold">
                              {{locSpecificCart?.purchaseOrderNumber!=''?locSpecificCart?.purchaseOrderNumber:locSpecificCart?.code}}
                            </td>
                          </tr>
                        }
                        @if (locSpecificCart?.cartType === 'INFLUENZA') {
                          <tr>
                            <td class="ff-bold">Influenza Order #:</td>
                            <td class="fw-bold">{{locSpecificCart?.code}}</td>
                          </tr>
                        }
                        @if (locSpecificCart?.cartType === 'INFLUENZA') {
                          <tr>
                            <td class="ff-bold">Influenza Vaccine PO #:</td>
                            <td class="fw-bold">
                              {{locSpecificCart?.purchaseOrderNumber!=''?locSpecificCart?.purchaseOrderNumber:locSpecificCart?.code}}
                            </td>
                          </tr>
                        }
                      </table>
                    </section>
                  </section>
                  <div class="row p-1 details-for-mb separatorLn">
                    <div class="col-xs-12 col-sm-3 p-2">
                      <div class="row">
                        <div class="col-12 mb-order-col">
                          <div class="order-detailsi-text order-detailsi-text-mb">Sold To</div>
                          <div>#{{locSpecificCart.shipToLoc_id}}</div>
                        </div>
                        <div class="col-12 mb-order-col">
                          <div class="order-detailsi-text  order-detailsi-text-mb">Order Date</div>
                          <div>{{getRequestedDate(locSpecificCart.created)}}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-4 p-2">
                      <div class="row">
                        <div class="col-12 mb-order-col">
                          <div class="order-detailsi-text  order-detailsi-text-mb shipToMobile">Ship To</div>
                          <div>
                            @if (locSpecificCart?.shipToLoc_name && locSpecificCart?.shipToLoc_name!='') {
                              <div>
                                {{locSpecificCart?.shipToLoc_name}}
                              </div>
                            }
                            <div>{{locSpecificCart?.shippingAddressOfLocation?.formattedAddress|uppercase}}
                            </div>
                          </div>
                        </div>
                      </div>
                      @if (locSpecificCart?.attention !== null && locSpecificCart?.attention !== undefined) {
                        <div class="row mt-2"
                          >
                          <div class="col-12 mb-order-col">
                            @if (locSpecificCart?.attention) {
                              <div class="order-detailsi-text  order-detailsi-text-mb">
                              Attention</div>
                            }
                            {{ locSpecificCart?.attention }}
                          </div>
                        </div>
                      }
                    </div>
                    <div class="col-xs-12 col-sm-5">
                      <div class="mb-1">
                        <span class="order-detailsi-text location-total">Location subtotal</span>
                        @if (headerLevelObj?.length==0) {
                          <span
                            class="order-detailsi-text location-total-amount txt-float-right">
                            {{locSpecificCart?.subTotal?.value+locSpecificCart?.totalExciseTax?.value | currency : 'USD' :
                            'symbol' : '1.2-2'}}
                          </span>
                        }
                        @if (headerLevelObj?.length>0) {
                          <span>$--</span>
                        }
                      </div>
                      @if (salesTaxFlag=='y') {
                        <div class="mb-1">
                          <span class="order-detailsi-text location-total savings-chg">Sales tax</span>
                          @if (headerLevelObj?.length==0) {
                            <span
                              class="order-detailsi-text location-total-amount txt-float-right savings-chg">
                              {{locSpecificCart?.totalSalesTaxPrice?.value | currency : 'USD' :
                              'symbol' : '1.2-2'}}
                            </span>
                          }
                          @if (headerLevelObj?.length>0) {
                            <span>$--</span>
                          }
                        </div>
                      } @else {
                        @if (locSpecificCart?.totalSalesTaxPrice && locSpecificCart?.totalSalesTaxPrice?.value>0) {
                          <div class="mb-1"
                            >
                            <span class="order-detailsi-text location-total savings-chg">Sales tax</span>
                            @if (headerLevelObj?.length==0) {
                              <span
                                class="order-detailsi-text location-total-amount txt-float-right savings-chg">
                                {{locSpecificCart?.totalSalesTaxPrice?.value | currency : 'USD' :
                                'symbol' : '1.2-2'}}
                              </span>
                            }
                            @if (headerLevelObj?.length>0) {
                              <span>$--</span>
                            }
                          </div>
                        }
                      }
                      @if (locSpecificCart.totalWebDiscount.value!=0) {
                        <div class="mb-1">
                          <span class="location-total savings-chg">{{baseSiteId=="vsh"?"VaccineShop Savings":"VaxServe.comSavings"}}</span>
                          @if (headerLevelObj?.length==0) {
                            <span class="location-total-amount txt-float-right text-success savings-chg"
                              >{{locSpecificCart.totalWebDiscount.value
                              |
                              currency : 'USD' :
                            'symbol' : '1.2-2'}}</span>
                          }
                          @if (headerLevelObj?.length>0) {
                            <span>$--</span>
                          }
                        </div>
                      }
                      @if (otherDiscountsFlag=='y') {
                        <div class="mb-1">
                          <span class="order-detailsi-text location-total savings-chg">Other discounts
                          </span>
                          @if (headerLevelObj?.length==0) {
                            <span class="location-total-amount txt-float-right text-success savings-chg"
                              >{{locSpecificCart?.totalOtherDiscount?.value
                              |
                              currency : 'USD' : 'symbol' : '1.2-2'}}
                            </span>
                          }
                          @if (headerLevelObj?.length>0) {
                            <span>$--</span>
                          }
                        </div>
                      } @else {
                        @if (locSpecificCart?.totalOtherDiscount && locSpecificCart?.totalOtherDiscount?.value!=0) {
                          <div class="mb-1"
                            >
                            <span class="order-detailsi-text location-total savings-chg">Other discounts
                            </span>
                            @if (headerLevelObj?.length==0) {
                              <span class="location-total-amount txt-float-right text-success savings-chg"
                                >{{locSpecificCart?.totalOtherDiscount?.value
                                |
                                currency : 'USD' : 'symbol' : '1.2-2'}}
                              </span>
                            }
                            @if (headerLevelObj?.length>0) {
                              <span>$--</span>
                            }
                          </div>
                        }
                      }
                      <div class="mb-1 bg-color">
                        <span class="order-detailsi-text location-total">Location Total</span>
                        @if (headerLevelObj?.length==0) {
                          <span class="order-detailsi-text location-total-amount txt-float-right"
                            >{{locSpecificCart.totalPrice.value
                          | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
                        }
                        @if (headerLevelObj?.length>0) {
                          <span>$--</span>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="row p-1 details-for-mb">
                    <div class="col-12">
                      <section class="row">
                        <div class="col-md-12">
                          <div class="panel-body p-0 m-0">
                            <section class="row row-20 pdp-list-product-data">
                              @if (showonHold && stdCartDetails.orders[i]?.deliveryBlock=='YD') {
                                <div class="col-10 leftRed"
                                  >
                                  <div class="row">
                                    <div class="col-1 topMargin">
                                      <p><img src="/icons/{{baseSiteId}}/warning_red_new.png" alt="faq_reg"
                                      class="faq" /></p>
                                    </div>
                                    <div class="col-10">
                                      <div style="margin-top:12px;">
                                        <p><strong>This order has been placed on HOLD</strong></p>
                                        <p>Per your company's policy, this order has been forwarded for approval to:<br />
                                          Name:&nbsp;{{stdCartDetails.orders[i]?.approver?.name}}<br />
                                          Phone:&nbsp;{{stdCartDetails.orders[i]?.approver?.phone}}<br />Once your order has
                                          been approved
                                          it
                                          will immediately be processed for shipment.<br />Thank you again for your order.
                                          Your
                                        complete order details are below.</p>
                                        <p>Sincerely<br /> {{baseSiteId=="vsh"?'VaccineShop Account Management':'VaxServe Account Management'}}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }
                            </section>
                            @for (productentry of locSpecificCart?.entries; track productentry; let j = $index) {
                              <section class="pdp-list-data"
                                style="border-top:0.0625em solid #e5e9ec">
                                <section class="row row-20 pdp-list-product-data">
                                  <div class="col-md-1">
                                    <section class="col-xs-12 col-sm-7 col-md-7 col-lg-7 pr0 cart_print">
                                      <a (click)="productDetails(productentry,i)">
                                        <img class="image-product" src="{{getImage(productentry.product?.images,'thumbnail')}}"
                                          alt="Product Img">
                                      </a>
                                    </section>
                                  </div>
                                  <div class="col-md-10 cart_print prodDetMobile marginleftCls">
                                    <a (click)="productDetails(productentry,i)">
                                      <h2 class="prod-title" [innerHTML]="productentry?.product?.baseProductName"></h2>
                                    </a>
                                    <section class="checkout-data">
                                      <a (click)="productDetails(productentry,i)">
                                        <p [innerHTML]="productentry?.product?.baseProductDescription"
                                        (click)="productDetails(productentry,i)" class="productCode prodDes"></p>
                                        <p [innerHTML]="stdFluDesc(productentry)" class="productCode prodDes"
                                        (click)="productDetails(productentry,i)"></p>
                                      </a>
                                      @if (productentry.product?.ndcCode) {
                                        <p class="ndcCode">
                                        {{productentry.product?.ndcCode}}</p>
                                      }
                                      <div>
                                        <p class="card-text">
                                          <span><strong>{{productentry?.product?.code}}</strong> |
                                        {{productentry?.product?.manufacturer}}</span>
                                        @if (productentry?.contractName) {
                                          <span
                                            [ngStyle]="{ 'margin-left': '10px'}"><strong>Contract Group:</strong>
                                          {{productentry?.contractName}}</span>
                                        }
                                      </p>
                                    </div>
                                    @if (productentry.product?.innerText && productentry.product?.innerText !== '') {
                                      <p class="inner-text"
                                        >
                                        <span [innerHtml]="productentry?.product?.innerText"></span>
                                      </p>
                                    }
                                  </section>
                                </div>
                              </section>
                              <section class="row marginleftCls">
                                <section class="col-sm-12 col-md-12 col-lg-12 data-pad">
                                  <table id="example1" style="width: 100%;"
                                    class="display account_invoice_financials dataTable no-footer">
                                    <thead>
                                      <tr class="heading">
                                        <th id="table1col1" class="date-new no-sort 1">Status</th>
                                        <th id="table1col2" class="date-new no-sort">Total Units</th>
                                        <th id="table1col3" class="invoice no-sort">Units in shipment</th>
                                        <th id="table1col4" class="po no-sort">Ship Date</th>
                                        <th id="table1col5" class="invoice-amount no-sort right">Unit Price</th>
                                        <th id="table1col6" class="discount no-sort right">Unit Excise Tax</th>
                                        <th id="table1col7" class="no-sort right">Subtotal</th>
                                      </tr>
                                    </thead>
                                    @if ((!productentry?.futureShipExpProd || (productentry?.futureShipExpProd && !productentry?.splitEntriesDeliveryDates) || (productentry?.futureShipExpProd && productentry?.splitEntriesDeliveryDates && productentry?.splitEntriesDeliveryDates?.length==0 ))) {
                                      <tbody class="datatable-row"
                                        >
                                        <tr class="odd dateshow 1">
                                          <td rowspan="2" headers="table1col 1">Open</td>
                                          <td>{{productentry?.quantity}}</td>
                                          <td>{{productentry?.quantity}}</td>
                                          <td>
                                            {{getRequestedDate(productentry?.estimatedDeliveryDate)}}<br>(Estimated)
                                          </td>
                                          <td class="right">@if (!productentry?.product?.hidePriceForProduct) {
                                            <span
                                              >{{productentry?.basePrice?.value
                                              |
                                              currency : 'USD' :
                                            'symbol' : '1.2-2'}}</span>
                                          }
                                          @if (productentry?.product?.hidePriceForProduct) {
                                            <span>$--</span>
                                          }
                                        </td>
                                        <td class="right">@if (!productentry?.product?.hidePriceForProduct) {
                                          <span
                                            >{{productentry.exciseTax.value
                                            | currency : 'USD' :
                                          'symbol' : '1.2-2'}}</span>
                                        }
                                        @if (productentry?.product?.hidePriceForProduct) {
                                          <span>$--</span>
                                        }
                                      </td>
                                      <td class="right">@if (!productentry?.product?.hidePriceForProduct) {
                                        <span
                                          >{{(productentry.totalPrice.value+productentry.exciseTax.value*productentry?.quantity)
                                          | currency : 'USD' :
                                        'symbol' : '1.2-2'}}</span>
                                      }
                                      @if (productentry?.product?.hidePriceForProduct) {
                                        <span>$--</span>
                                      }
                                    </td>
                                  </tr>
                                </tbody>
                              }
                              @if (productentry?.futureShipExpProd && productentry?.splitEntriesDeliveryDates?.length>0) {
                                <tbody class="datatable-row"
                                  >
                                  @for (item of productentry.splitEntriesDeliveryDates; track item; let i = $index) {
                                    <tr class="odd dateshow"
                                      >
                                      @if (i==0) {
                                        <td [attr.rowspan]="productentry?.splitEntriesDeliveryDates?.length"
                                        headers="table1col1">{{i==0?'Open':' '}}</td>
                                      }
                                      @if (i>0) {
                                        <td></td>
                                      }
                                      <td>{{i==0?productentry.quantity:item.splitQuantity}}</td>
                                      <td style="white-space: pre-line"
                                        [innerHTML]="getQtyOrShipDate(i,item.splitdeliveryDate,item.splitQuantity,'quantity')">
                                      </td>
                                      <td style="white-space: pre-line"
                                      [innerHTML]="getQtyOrShipDate(i,item.splitdeliveryDate,'','date')"></td>
                                      <td class="right">
                                        {{i==0?'$'+productentry?.basePrice?.value:''}}
                                      </td>
                                      <td class="right">{{i==0?(productentry.exciseTax.value| currency : 'USD' :'symbol' :
                                      '1.2-2'):''}}</td>
                                      <td class="right">
                                        {{i==0?((productentry?.basePrice?.value+productentry.exciseTax.value)*productentry.quantity|
                                        currency : 'USD' : 'symbol' : '1.2-2'):''}}
                                      </td>
                                    </tr>
                                  }
                                </tbody>
                              }
                            </table>
                            <table id="mb-example1" style="width: 100%;"
                              class="display account_invoice_financials dataTable no-footer">
                              @if ((!productentry?.futureShipExpProd || (productentry?.futureShipExpProd && !productentry?.splitEntriesDeliveryDates) || (productentry?.futureShipExpProd && productentry?.splitEntriesDeliveryDates?.length==0 ))) {
                                <tbody class="datatable-row"
                                  >
                                  <tr class="odd dateshow">
                                    <td class="left-td 2">Status</td>
                                    <td class="2">Open</td>
                                  </tr>
                                  <tr class="odd dateshow">
                                    <td class="left-td">Total Units</td>
                                    <td>{{productentry?.quantity}}</td>
                                  </tr>
                                  <tr class="odd dateshow">
                                    <td class="left-td">Units in shipment</td>
                                    <td>{{productentry?.quantity}}</td>
                                  </tr>
                                  <tr class="odd dateshow">
                                    <td class="left-td">Ship Date</td>
                                    <td>
                                      {{getRequestedDate(productentry?.estimatedDeliveryDate)}}<br>(Estimated)
                                    </td>
                                  </tr>
                                  <tr class="odd dateshow">
                                    <td class="left-td">Unit Price</td>
                                    <td class="right">{{productentry?.totalPrice?.value | currency : 'USD' :
                                      'symbol' : '1.2-2'}}
                                    </td>
                                  </tr>
                                  <tr class="odd dateshow">
                                    <td class="left-td">Unit Excise Tax</td>
                                    <td class="right">{{productentry.exciseTax.value | currency : 'USD' :
                                    'symbol' : '1.2-2'}}</td>
                                  </tr>
                                  <tr class="odd dateshow">
                                    <td class="left-td">Subtotal</td>
                                    <td class="right">
                                      {{(productentry.totalPrice.value+productentry.exciseTax.value*productentry?.quantity)
                                      |
                                      currency : 'USD' :
                                      'symbol' : '1.2-2'}}
                                    </td>
                                  </tr>
                                </tbody>
                              }
                              @if (productentry?.futureShipExpProd && productentry?.splitEntriesDeliveryDates?.length>0) {
                                <tbody class="datatable-row"
                                  >
                                  @for (item of productentry.splitEntriesDeliveryDates; track item; let i = $index) {
                                    <tr class="odd dateshow"
                                      >
                                      <td [attr.rowspan]="productentry?.splitEntriesDeliveryDates?.length"
                                      headers="table1col1">{{i==0?'Open':' '}}</td>
                                      <td>{{i==0?productentry.quantity:item.splitQuantity}}</td>
                                      <td style="white-space: pre-line"
                                        [innerHTML]="getQtyOrShipDate(i,item.splitdeliveryDate,item.splitQuantity,'quantity')">
                                      </td>
                                      <td style="white-space: pre-line"
                                      [innerHTML]="getQtyOrShipDate(i,item.splitdeliveryDate,'','date')"></td>
                                      <td class="right">
                                        {{i==0?'$'+productentry?.basePrice?.value:''}}
                                      </td>
                                      <td class="right">{{i==0?(productentry.exciseTax.value|currency:'USD'
                                      :'symbol':'1.2-2'):''}}</td>
                                      <td class="right">
                                        {{i==0?(((productentry?.basePrice?.value+productentry.exciseTax.value)*productentry.quantity)|currency:'USD':'symbol'
                                        : '1.2-2'):''}}
                                      </td>
                                    </tr>
                                  }
                                </tbody>
                              }
                            </table>
                          </section>
                        </section>
                      </section>
                    }
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      }
      <!-- accordion: end-->
    </section>
  </div>

</div>
<div class="col-sm-4 col-md-4 col-lg-4 m-0 p-0" style="border-left:4px solid #f4f2f6;">
      <aside class="
      col-md-12 col-sm-12 m-0 p-0
      right-navigation
      float-left
      left-align
      cart-main-page dst-orderSubtotal
    " [ngClass]="isSticky === true ? 'header' : ''" aria-label="subTotal">
    <section class="savings-total p-0 two">

      <div class="row">
        <div class="col-md-12 col-sm-12 col-lg-12 m-0 p-0">
          <div class="background-grey">

            <div class="orderTitleSticky">
              Order Total:
              @if (headerLevelObj?.length==0) {
                <span>
                  {{ subTotalVal | currency : 'USD' :
                  'symbol' : '1.2-2' }}
                </span>
              }
              @if (headerLevelObj?.length>0) {
                <span>$--</span>
              }

            </div>
            <p class="fw-bold m-0 p-0">Total Savings:&nbsp;@if (headerLevelObj?.length==0) {
              <span
                class="greenfont">{{totalSavings | currency : 'USD'
              : 'symbol' : '1.2-2'}}</span>
              }@if (headerLevelObj?.length>0) {
              <span>$--</span>
            } </p>

          </div>

        </div>
      </div>



    </section>

    <section>

    </section>


  </aside>
      <aside class="
      col-md-12 col-sm-12
      right-navigation
      float-left
      left-align
      cart-main-page
    " aria-label="subTotal">
    <div class="p-0 m-0" [class.payMethod-marTop]="isSticky">
      <app-payment-method [orderFlu]="true" [stdCartType]="true" [cancelFluReservation]="true"
      [paymentMethod]="stdCartDetails?.orders[0]?.paymentMethod" [cardDetails]="cardDetails"></app-payment-method>
    </div>
  </aside>
      <aside class="
      col-md-12 col-sm-12
      right-navigation
      float-left
      left-align
      cart-main-page
    " aria-label="subTotal">
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <h2 class="orderContact">
        Order contact</h2>
      </div>
    </div>

    <!--Payment Method-->
    <div class="reserve-contact">


      <div class="row">
        <div class="col-md-4 formLabel productCode productCodeMb">Order placed by</div>
        <div class="col-md-8 fw-normal-contact">{{stdCartDetails?.orders[0]?.orderContactData?.name}}</div>
      </div>

      @if (showphoneNo) {
        <div class="row">
          <div class="col-md-4 formLabel productCode productCodeMb">Phone</div>
          <div class="col-md-8 fw-normal-contact">{{stdCartDetails?.orders[0]?.orderContactData?.phoneNo}}</div>
        </div>
      }

      @if (showmobileNo) {
        <div class="row">
          <ng-template #errorPopContent>Add mobile number to receive shipping/delivery texts</ng-template>
          <div class="col-md-4 formLabel productCode productCodeMb">Mobile<a placement="top"
            [ngbPopover]="errorPopContent"><img src="/icons/{{baseSiteId}}/faqs-plum.svg"
          alt="faq_reg" class="faq" /></a></div>
          <div class="col-md-8 fw-normal-contact">{{stdCartDetails?.orders[0]?.orderContactData.mobileNo}}</div>
        </div>
      }
      @if (stdCartDetails?.orders[0]?.orderContactData?.additionalMobiles?.length > 0) {
        @for (mob of stdCartDetails?.orders[0]?.orderContactData?.additionalMobiles; track mob) {
          <div class="row">
            <div class="col-md-4 formLabel"></div>
            <div class="col-md-8 fw-normal-contact">{{mob}}</div>
          </div>
        }
      }


      @if (stdCartDetails?.orders[0]?.orderContactData?.email!='') {
        <div class="row">
          <div class="col-md-4 formLabel productCode productCodeMb">Email</div>
          <div class="col-md-8 fw-normal-contact formVal"><a class="reservation_email fw-normal-contact formVal"
          href="mailto:{{stdCartDetails?.orders[0]?.orderContactData.email}}">{{stdCartDetails?.orders[0]?.orderContactData.email}}</a>
        </div>
      </div>
    }
    @if (stdCartDetails?.orders[0]?.orderContactData?.additionalEmails?.length > 0) {
      @for (email of stdCartDetails?.orders[0]?.orderContactData?.additionalEmails; track email) {
        <div class="row">
          <div class="col-md-4 formLabel"></div>
          <div class="col-md-8 fw-normal-contact formVal">
            <a class="reservation_email fw-normal-contact formVal" href="mailto:{{email}}">{{email}}</a>
          </div>
        </div>
      }
    }
    @if (stdCartDetails?.orders[0]?.orderContactData?.fax!='') {
      <div class="row">
        <div class="col-md-4 formLabel productCode productCodeMb">Fax</div>
        <div class="col-md-8 fw-normal-contact">{{stdCartDetails?.orders[0]?.orderContactData.fax}}
        </div>
      </div>
    }




    <div class="row">
      <div class="col-md-4 formLabel productCode productCodeMb">Placed By</div>
      <div class="col-md-8 fw-normal-contact">{{stdCartDetails?.orders[0]?.orderContactData?.placedBy ?
        stdCartDetails?.orders[0]?.orderContactData?.placedBy :
      stdCartDetails?.orders[0]?.orderContactData?.name}}</div>

    </div>
    @if (isAsmUser && stdCartDetails?.orders[0]?.orderContactData?.salesRepEmail) {
      <div class="row">
        <div class="col-md-4 formLabel productCode productCodeMb">Email</div>
        <div class="col-md-8 fw-normal-contact formVal"><a class="reservation_email fw-normal-contact formVal"
        href="mailto:{{stdCartDetails?.orders[0]?.orderContactData?.salesRepEmail}}">{{stdCartDetails?.orders[0]?.orderContactData?.salesRepEmail}}</a>
      </div>
    </div>
  }

</div>
<!--End of Payment Method-->


<div class="row">
  <div class="col-md-6 col-sm-6 mobileWidthPadding">
    <h3 class="productCode">Billing Address</h3>



    <p class="dataforaddblock">{{orderContactDetails?.accountNumber}}<br />
      @if (orderContactDetails?.companyName) {
        <span>{{orderContactDetails?.companyName}}<br /></span>
      }
      <!-- CTR FOR DISEASE CONTROL AND PREV<br /> -->

      {{orderContactDetails?.formattedAddress}}
    </p>
  </div>
  <div class="col-md-6 col-sm-6 mobileWidthPadding">
    <h3 class="productCode">Payer address</h3>
    <p class="dataforaddblock">{{payerAddress?.accountNumber}}<br />
      @if (payerAddress?.companyName) {
        <span>{{payerAddress?.companyName}}<br /></span>
      }
      <!-- CTR FOR DISEASE CONTROL AND PREV<br /> -->

      {{payerAddress?.formattedAddress}}
    </p>
  </div>
</div>
</aside>
</div>
</div>
</section>
<ng-template #emptyCart>
  <app-empty-cart compName="EmptyCartParagraphComponent"></app-empty-cart>
</ng-template>

<ng-template #content let-modal>
  <div class="modal-header">
    <h3 class="modal-title modalTitle">Ready to place your order?</h3>
  </div>
  <div class="modal-body">

    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12">
        <div class="fw-bold-center marginleftCls p-0">Order total</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12">
        <div class="fw-bold-centr-amount marginleftCls">$61.62</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12">
        <div class="no-sort-center marginleftCls p-0">Total with Prompt Pay: $60.46</div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12 separator">
        &nbsp;
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12">
        <div class="fw-bold-center marginleftCls p-0">Ship to locations</div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12">
        <div class="fw-bold-center marginleftCls p-0">Address</div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12 separator">
        &nbsp;
      </div>
    </div>


    <div class="row">
      <div class="col-md-6 col-sm-6 col-lg-6">
        <div class="fw-bold-center marginleftCls p-0">Order Contact</div>
      </div>

      <div class="col-md-6 col-sm-6 col-lg-6">
        <div class="fw-bold-center marginleftCls p-0">Payment Method</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-6 col-lg-6">
        <div class="fw-bold-center marginleftCls p-0">Order Contact</div>
      </div>

      <div class="col-md-6 col-sm-6 col-lg-6">
        <div class="fw-bold-center marginleftCls p-0">Payment Method</div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12 separator">
        &nbsp;
      </div>
    </div>

    <div class="row m-0 p-0">
      <div class="col-lg-9 col-sm-9 col-md-9">
        @if (!updateTotal) {
          <button type="button" class="btn btn-default blue-button mt2 placeOrderBtn"
            (click)="proceedtoFinal()" [disabled]="orderBlock || checkoutClicked || yfEntry"
            [ngClass]="orderBlock || yfEntry ? 'disableCTA' : ''">
            @if (checkoutClicked) {
              <i class="fa fa-spinner fa-spin"></i>
            }
            Yes, place order
          </button>
        }
        <button class="btn btn-default white-button mt2 EditOrderBtn" (click)="modal.dismiss()">
          Edit Order
        </button>
      </div>
    </div>

  </div>
</ng-template>
}
